<div class="aa">
  <h2 class="aa-title">Auction catalogue import</h2>
  <p class="aa-note">
    Manual import (first-loop scope). Paste lots as CSV
    (<code>lot,registration,guide£</code> per line) or a JSON array. Preview
    the PlateX classifications, then import — classify, persist, emit the
    canonical event and generate interest matches.
  </p>

  <div class="aa-grid">
    <label>House<select [(ngModel)]="house">
      <option value="dvla">DVLA</option>
      <option value="collecting_cars">Collecting Cars</option>
    </select></label>
    <label>Auction code<input [(ngModel)]="auctionCode" placeholder="e.g. B285" /></label>
    <label>Title<input [(ngModel)]="title" placeholder="DVLA July auction" /></label>
    <label>Model<select [(ngModel)]="providerModel">
      <option value="timed_event">Timed event (DVLA)</option>
      <option value="rolling">Rolling (Collecting Cars)</option>
    </select></label>
    <label>Opens<input type="datetime-local" [(ngModel)]="opensAt" /></label>
    <label>Closes<input type="datetime-local" [(ngModel)]="closesAt" /></label>
  </div>

  <label class="aa-lots">Lots
    <textarea [(ngModel)]="rawLots" rows="8"
      placeholder="1,PLA 73X,2000&#10;2,1 NR,224000&#10;3,J4 MES,24995"></textarea>
  </label>

  <div class="aa-actions">
    <button type="button" (click)="runPreview()" [disabled]="busy || !auctionCode">Preview</button>
    <button type="button" class="primary" (click)="runImport()" [disabled]="busy || !auctionCode">Import</button>
  </div>

  <p class="aa-error" *ngIf="error">{{ error }}</p>

  <div class="aa-preview" *ngIf="preview">
    <p class="aa-summary">
      Preview · {{ preview.lotsSeen }} lots ({{ preview.lotsNew }} new,
      {{ preview.lotsExisting }} existing, {{ preview.lotsRemoved }} would be removed)<span
        *ngIf="preview.sameChecksum"> · identical to current catalogue (import would be a no-op)</span>
    </p>
    <table class="aa-table">
      <tr><th>Lot</th><th>Plate</th><th>Format</th><th>№</th><th>Initials</th><th>Name</th><th>Collections</th></tr>
      <tr *ngFor="let l of preview.lots">
        <td>{{ l.lotNumber }}</td>
        <td><pla-plate [rawPlate]="l.registration" [showPrice]="false" [openModal]="false"
          [clickThrough]="false" [center]="false" [mobileSmall]="true" [customClass]="'flat shaded'" [plateSize]="'ns-s'"></pla-plate></td>
        <td>{{ l.format || '—' }}</td>
        <td>{{ l.numberValue ?? '—' }}<span *ngIf="l.isNumberOne" class="aa-tag">№1</span></td>
        <td>{{ l.initials || '—' }}</td>
        <td>{{ l.nameMatch || '—' }}</td>
        <td>{{ l.collections?.length ? l.collections.join(', ') : '—' }}</td>
      </tr>
    </table>
  </div>

  <p class="aa-ok" *ngIf="importResult && !importResult.rejectedReason">
    Imported · auction #{{ importResult.auctionId }} · catalogue v{{ importResult.catalogueVersion }}
    · {{ importResult.lotsAdded }} added, {{ importResult.lotsUpdated }} updated,
    {{ importResult.lotsRemoved }} removed<span *ngIf="importResult.noOp"> · no-op (same checksum)</span>.
    Matches generated; the homepage For You updates on next load.
  </p>
</div>
